import React from 'react';
import './Input.scss';

const Input = ({ label, name, value, onChange, type = 'text', placeholder = '', required = false, error = '', className = '', disabled = false, readOnly = false, ...props }) => {
    return (
        <div className={`input-group ${className}`}>
            {label && <label htmlFor={name}>{label}{required && <span className="required">*</span>}</label>}
            <input
                id={name}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                className={error ? 'error' : ''}
                {...props}
            />
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default Input;
